/**
 * Build a query string
 * @returns A builder object with an add method and a toString method
 * @example
 * ```ts
 * const query = QueryBuilder().add("name", "John").toString();
 * const url = `https://example.com?${query}`;
 * ```
 */
export function QueryBuilder() {
    const params = new URLSearchParams();
    const builder = {
        add: (key, value) => {
            if (value !== undefined) {
                params.append(key, value.toString());
            }
            return builder;
        },
        toString: () => params.toString(),
    };
    return builder;
}
